/**
 * Browser compatibility utilities for handling issues with specific devices/browsers
 */

export interface BrowserInfo {
  userAgent: string;
  isCisco: boolean;
  isWebKit: boolean;
  isChrome: boolean;
  isFirefox: boolean;
  isSafari: boolean;
  supportsStreams: boolean;
  supportsFetch: boolean;
  supportsEventTarget: boolean;
}

export const getBrowserInfo = (): BrowserInfo => {
  const userAgent = navigator.userAgent;

  return {
    userAgent,
    isCisco: /cisco/i.test(userAgent),
    isWebKit: /webkit/i.test(userAgent),
    isChrome: /chrome/i.test(userAgent) && !/edge/i.test(userAgent),
    isFirefox: /firefox/i.test(userAgent),
    isSafari: /safari/i.test(userAgent) && !/chrome/i.test(userAgent),
    supportsStreams: typeof ReadableStream !== 'undefined' && typeof WritableStream !== 'undefined',
    supportsFetch: typeof fetch !== 'undefined',
    supportsEventTarget: typeof EventTarget !== 'undefined',
  };
};

export const logBrowserInfo = (): void => {
  const info = getBrowserInfo();
  console.log('Browser Compatibility Info:', info);

  // Log potential issues
  if (info.isCisco) {
    console.warn('Cisco device detected - may have compatibility issues');
  }

  if (!info.supportsStreams) {
    console.error('Browser does not support Streams API');
  }

  if (!info.supportsFetch) {
    console.error('Browser does not support Fetch API');
  }

  if (!info.supportsEventTarget) {
    console.error('Browser does not support EventTarget');
  }
};

export const checkStreamSupport = (): boolean => {
  try {
    // Test if the browser supports the specific stream features we use
    new ReadableStream({
      start(controller) {
        controller.enqueue('test');
        controller.close();
      },
    });

    new TextDecoderStream();
    new EventTarget();

    return true;
  } catch (error) {
    console.error('Stream support test failed:', error);
    return false;
  }
};
